import RoadmapScreen from "@/components/roadmap/RoadmapPage";

export default function RoadmapPage() {
  return <RoadmapScreen />;
}
